import React from 'react';
const pilastri = [{
  emoji: '📚',
  title: '6 Annual Volumes',
  desc: 'A complete 12-month roadmap covering Foundation, Intermediate, and Advanced levels.',
  color: 'bg-primary'
}, {
  emoji: '🩺',
  title: 'Clinical Foundations',
  desc: 'How to teach safely and effectively for common spinal pathologies and injuries.',
  color: 'bg-secondary'
}, {
  emoji: '🤰',
  title: 'Specialist Populations',
  desc: 'Fully-charted routines for Pre-natal, Post-natal, and Seniors with safe adaptations.',
  color: 'bg-accent-sage'
}, {
  emoji: '🌊',
  title: 'The Art of "Flow"',
  desc: 'Mastery of transitions for high-end, seamless classes that feel like poetry.',
  color: 'bg-badge-red'
}];
const materiali = [{
  emoji: '📖',
  title: 'The 6 Master Volumes (+200 pages)',
  desc: 'The complete technical guide with explanations, technical diagrams, and logical progressions.'
}, {
  emoji: '📋',
  title: 'Assessment & Intake Suite (+40 pages)',
  desc: 'Professional observation grids and intake forms ready to hand to your clients.'
}, {
  emoji: '💪',
  title: 'Dynamic Pilates Manual (+80 pages)',
  desc: 'High-energy sequences including Magic Circle, Bands, and Balls integrations.'
}, {
  emoji: '🗂️',
  title: 'The "Quick-Reference" Deck',
  desc: 'Visual class maps for your mat-side consultation during live sessions.'
}];
export function ContentPreview() {
  return <section className="w-full bg-bg-alt py-20 px-4" data-id="element-24">
      <div className="max-w-5xl mx-auto" data-id="element-25">
        <div className="text-center mb-16" data-id="element-26">
          <span className="text-4xl mb-4 block" data-id="element-27">🎁</span>
          <h2 className="text-3xl sm:text-5xl font-serif font-black text-text-main mb-4 tracking-tight" data-id="element-28">
            What's inside the Vault?
          </h2>
          <p className="text-text-sec text-lg sm:text-xl max-w-2xl mx-auto" data-id="element-29">
            Everything an Australian studio needs in one single digital
            curriculum. Four pillars of technical content designed to eliminate
            stress and let your classes shine.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 mb-20" data-id="element-30">
          {pilastri.map((item, i) => <div key={i} className="bg-white rounded-2xl border border-border-light overflow-hidden flex flex-col relative group hover:-translate-y-1 transition-transform duration-300 shadow-[0_4px_15px_rgba(201,137,155,0.05)]" data-id="element-31">
              <div className={`${item.color} h-1.5 w-full opacity-80`} data-id="element-32" />
              <div className="flex-1 flex flex-col p-8 relative" data-id="element-33">
                <div className={`absolute inset-0 ${item.color} opacity-[0.02] group-hover:opacity-[0.05] transition-opacity`} data-id="element-34"></div>
                <span className="text-4xl mb-4 block relative z-10 group-hover:scale-110 transition-transform duration-300" data-id="element-35">
                  {item.emoji}
                </span>
                <h3 className="text-xl font-bold text-text-main leading-snug relative z-10 mb-2" data-id="element-36">
                  {item.title}
                </h3>
                <p className="text-text-sec text-base leading-relaxed relative z-10" data-id="element-37">
                  {item.desc}
                </p>
              </div>
            </div>)}
        </div>

        <div className="bg-white rounded-3xl border border-border-light p-8 sm:p-12 shadow-[0_8px_30px_rgba(201,137,155,0.08)]" data-id="element-38">
          <div className="text-center mb-10" data-id="element-39">
            <span className="text-4xl mb-4 block" data-id="element-40">📦</span>
            <h3 className="text-2xl sm:text-4xl font-serif font-black text-text-main mb-4" data-id="element-41">
              Instant Download
            </h3>
            <p className="text-text-sec text-lg" data-id="element-42">
              350+ pages of ready-to-teach material. Print-ready PDFs (A4) or
              optimised for digital use on any device.
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6" data-id="element-43">
            {materiali.map((mat, i) => <div key={i} className="flex items-start gap-4 p-4 rounded-xl hover:bg-bg-main transition-colors" data-id="element-44">
                <div className="text-3xl flex-shrink-0" data-id="element-45">{mat.emoji}</div>
                <div data-id="element-46">
                  <h4 className="font-bold text-text-main mb-1" data-id="element-47">{mat.title}</h4>
                  <p className="text-text-sec text-sm leading-relaxed" data-id="element-48">
                    {mat.desc}
                  </p>
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}